import { dismissBulkMutationOptions } from "../../api/routes/remediation/bulk.ts";
import { useToast } from "@sg-protect/components";
import { useMutation } from "@tanstack/react-query";

export function useDismissOperation(bulkId: string) {
    const toast = useToast();
    // onError lives here rather than in mutate(): opening the card unmounts it before the request settles.
    const { mutate, isPending } = useMutation({
        ...dismissBulkMutationOptions(),
        onError: () => {
            toast.error("Failed to dismiss the operation. Please try again.");
        }
    });

    const dismiss = () => {
        if (!isPending) {
            mutate({ params: { path: { bulkId } } });
        }
    };

    return { dismiss, isPending };
}
